import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { ListingDisclaimer } from '~/apps/consumer/pages/Storefront/ListingDisclaimer';
import { ViewComps } from '../../../Comparables/ViewComps/ViewComps';
import { useBuyerOfferAnalysisContext } from '../../Context/BuyerOfferAnalysisContext';

export const ViewCompsModal = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const {
    listing,
    comparableSet,
    comps,
    isViewCompsModalOpen,
    onViewCompsModalClose,
    buyerOfferAnalysisLoading,
  } = useBuyerOfferAnalysisContext();

  const mainListing = listing;

  if (!mainListing) {
    if (!buyerOfferAnalysisLoading) {
      onViewCompsModalClose();
    }

    return null;
  }

  return (
    <Modal
      isOpen={isViewCompsModalOpen}
      scrollBehavior="inside"
      size="full"
      trapFocus={false}
      onClose={onViewCompsModalClose}
    >
      <ModalContent>
        <ModalHeader>View Comps</ModalHeader>
        <ModalCloseButton />
        <ModalBody
          ref={containerRef}
          px={{ base: 0, md: 10 }}
          py={{ base: 0, md: 4 }}
        >
          <Flex direction="column" gap={4}>
            <ViewComps
              comparableSet={comparableSet}
              comps={comps}
              listing={listing}
            />
            <ListingDisclaimer mls={listing?.mlsListing?.mls} />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
